module.exports = __webpack_public_path__ + "static/media/dimitar_trajanov.bf4b5508.jpeg";